import React from 'react'
import PropTypes from 'prop-types'

const Graph = ({ className, style }) => (
    <svg
        className={className}
        style={style}
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="285.708px"
        height="23.92px"
        viewBox="0 0 285.708 23.92"
    >
        <path
            d="M11.961,7.974c2.198,0,3.986,1.784,3.986,3.987c0,2.2-1.788,3.987-3.986,3.987S7.974,14.16,7.974,11.96C7.974,9.758,9.763,7.974,11.961,7.974 M11.961,23.92c5.189,0,9.573-3.342,11.224-7.973h262.523V7.974H23.185C21.534,3.343,17.15,0,11.961,0C5.366,0,0,5.365,0,11.96C0,18.555,5.366,23.92,11.961,23.92"
        />
    </svg>
)

Graph.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
}

Graph.defaultProps = {
    className: '',
    style: {},
}

export default Graph



// WEBPACK FOOTER //
// ./src/components/Slider/Bullets/Graph.jsx